import { defineComponent as _defineComponent } from 'vue'
import ListItemText from "@/components-UI/list/items/ListItemText.vue";
import { computed } from "vue";

interface Props {
    value: string,
    digits?: number,
    symbol?: string,
    color?: 'red' | 'green',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemNumber',
  props: {
    value: null,
    digits: { default: 2 },
    symbol: null,
    color: null
  },
  setup(__props: any) {

const props = __props as { value: string, digits: number, symbol?: string, color?: 'red' | 'green' }




const getValue = computed(() => {
    return Number(props.value).toLocaleString('ru-RU', {
        minimumFractionDigits: props.digits,
        maximumFractionDigits: props.digits,
    });
});


return { __sfc: true,props, getValue, ListItemText }
}

})